import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_URL } from '@core/core.tokens';
import { ActiveSession, ActiveSessionsCategory, ActiveUser, DashboardAggregated } from '@core/models/dashboard.model';
import { IQuery, PaginatedResults } from '@utils';
import { first } from 'rxjs/operators';

@Injectable()
export class DashboardService {

  constructor(
    private http: HttpClient,
    @Inject(API_URL) private apiUrl: string
  ) { }

  getAggregated() {
    return this.http.get<DashboardAggregated>(`${this.apiUrl}/dashboard/aggregated`).pipe(first());
  }

  getActiveSessions(query: IQuery) {
    return this.http.post<PaginatedResults<ActiveSession>>(`${this.apiUrl}/dashboard/active-sessions`, query).pipe(first());
  }

  getActiveUsers(query: IQuery) {
    return this.http.post<PaginatedResults<ActiveUser>>(`${this.apiUrl}/dashboard/active-users`, query).pipe(first());
  }

  getActiveSessionsCategories() {
    return this.http.get<ActiveSessionsCategory[]>(`${this.apiUrl}/dashboard/active-sessions-categories`).pipe(first());
  }

}
